import { render } from "./CreateLessonPage.vue?vue&type=template&id=0f5c3500&scoped=true"
import script from "./CreateLessonPage.vue?vue&type=script&lang=js"
export * from "./CreateLessonPage.vue?vue&type=script&lang=js"

import "./CreateLessonPage.vue?vue&type=style&index=0&id=0f5c3500&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5c3500"]])

export default __exports__